import ErrorBoundary from '../../../components/ErrorBoundary';
import { useState } from 'react';
import './style.css';
import Input from '../../../components/input';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from 'react-bootstrap/Table';
// import { useCubeQuery } from '../../../hooks/useCubeQuery';
import { PermissionGate } from '../../../contexts/PermissionGate';

interface Usuario {
  id: number;
  nome: string;
  sobrenome: string;
  email: string;
  nivel_acesso: string;
  departamento: string;
  empresa: string;
  fundos_id?: string;
  relacao?: string;
}

const CadastroUsuario = () => {
  const [modais, setModais] = useState({
    novoUsuario: false,
    edicaoUsuario: false,
    confirmacaoSaida: false
  });

  const [dadosModais, setDadosModais] = useState({
    usuarioSelecionado: null as Usuario | null,
    usuarioParaEdicao: null as Usuario | null,
    novoUsuario: {
      nome: '',
      sobrenome: '',
      email: '',
      nivel_acesso: '',
      departamento: '',
      acesso: '',
      fundos_id: '',
      relacao: '',
      empresa: ''
    }
  });

  const [errors, setErrors] = useState<Partial<Usuario>>({});

  const departamentos = [
    'Administração',
    'Financeiro',
    'Marketing',
    'Recursos Humanos',
    'Tecnologia da Informação',
    'Vendas',
    'Operações',
    'Jurídico',
    'Comercial',
    'Produção'
  ];

  const niveisAcesso = [
    'Admin',
    'Gestor',
    'Usuário',
    'Operador',
    'Visualizador'
  ];

  // const modelosTelas = JSON.parse(localStorage.getItem("ScreenDataModels") || "[]");
  // const { data: dataFundos, loading: loadingFundos, error: errorFundos } = useCubeQuery(modelosTelas.fundo?.cubeQuery || {});
  // const { data: dataEmpresas, loading: loadingEmpresas, error: errorEmpresas } = useCubeQuery(modelosTelas.empresa?.cubeQuery || {});

  // const fundos = dataFundos && Array.isArray(dataFundos) && dataFundos.length > 0
  //   ? dataFundos.map((fundo: any, index: number) => {
  //       return { 
  //         id: fundo['fundo.id'],
  //         nome: fundo['fundo.nome_fantasia'] 
  //       };
  //     })
  //   : [];

  // const empresas = dataEmpresas && Array.isArray(dataEmpresas) && dataEmpresas.length > 0
  //   ? dataEmpresas.map((empresa: any, index: number) => {
  //       return { 
  //         id: empresa['empresa.id'],
  //         nome: empresa['empresa.nome_fantasia'] 
  //       };
  //     })
  //   : [];

  const mockData = [
    { id: 1, nome: 'João', sobrenome: 'Silva', email: 'joao.silva@gmail.com', nivel_acesso: 'Admin', departamento: 'Administração', empresa: 'Empresa 1', fundos_id: '1', relacao: 'aprovador_cessao' },
    { id: 2, nome: 'Maria', sobrenome: 'Santos', email: 'maria.santos@gmail.com', nivel_acesso: 'Usuário', departamento: 'Financeiro', empresa: 'Empresa 2', fundos_id: '2', relacao: 'batimento_cota' },
    { id: 3, nome: 'Pedro', sobrenome: 'Oliveira', email: 'pedro.oliveira@gmail.com', nivel_acesso: 'Gestor', departamento: 'Marketing', empresa: 'Empresa 3', fundos_id: '3', relacao: 'aprovador_cessao' },
  ];

  const isAdmin = localStorage.getItem('is_admin') === 'true';

  const abrirModalNovoUsuario = () => {
    setModais(prev => ({ ...prev, novoUsuario: true }));
  };

  const abrirModalEdicao = (usuario: Usuario) => {
    setModais(prev => ({ ...prev, edicaoUsuario: true }));
    setDadosModais(prev => ({ ...prev, usuarioParaEdicao: usuario }));
  };

  const fecharModal = (tipoModal: keyof typeof modais) => {
    setModais(prev => ({ ...prev, [tipoModal]: false }));
  };

  return (
    <ErrorBoundary>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 className="card-title">Cadastro de Usuários</h5>
        <PermissionGate required="REGISTER_USER">
          <button
            className="fn-button fn-button--emphasized"
            onClick={abrirModalNovoUsuario}
          >
            <div className="fn-button__text">
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
              Novo Usuário
            </div>
          </button>
        </PermissionGate>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Sobrenome</th>
            <th>Email</th>
            <th>Nível de Acesso</th>
            <th>Departamento</th>
            <th>Empresa</th>
            <th>Editar</th>
          </tr>
        </thead>
        <tbody>
          {mockData.map((item) => (
            <tr key={item.id}>
              <td>{item.nome}</td>
              <td>{item.sobrenome}</td>
              <td>{item.email}</td>
              <td>{item.nivel_acesso}</td>
              <td>{item.departamento}</td>
              <td>{item.empresa}</td>
              <td>
                {isAdmin && (
                  <button
                    className="fn-button fn-button--icon fn-button--secondary"
                    onClick={() => abrirModalEdicao(item)}
                    title="Editar usuário"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faEdit} />
                    </div>
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
{/* 
      <PermissionGate required="REGISTER_USER">
        {modais.novoUsuario && (
          <div className="modal-overlay" onClick={() => fecharModal('novoUsuario')}>
            <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3 className="modal-title">Novo Usuário</h3>
                <button
                  className="modal-close"
                  onClick={() => fecharModal('novoUsuario')}
                  title="Fechar"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="form-section">
                  <h4 className="section-title">Dados do Usuário</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Nome</label>
                      <input
                        type="text"
                        className="form-input"
                        value={dadosModais.novoUsuario.nome}
                        onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, nome: e.target.value } }))}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Sobrenome</label>
                      <input
                        type="text"
                        className="form-input"
                        value={dadosModais.novoUsuario.sobrenome}
                        onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, sobrenome: e.target.value } }))}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Email</label>
                      <input
                        type="email"
                        className="form-input"
                        value={dadosModais.novoUsuario.email}
                        onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, email: e.target.value } }))}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Nível de Acesso</label>
                      <select
                        className="form-input"
                        value={dadosModais.novoUsuario.nivel_acesso}
                        onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, nivel_acesso: e.target.value } }))}
                        required
                      >
                        <option value="">Selecione o nível de acesso</option>
                        {niveisAcesso.map((nivel) => (
                          <option key={nivel} value={nivel}>
                            {nivel}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Departamento</label>
                    <select
                      className="form-input"
                      value={dadosModais.novoUsuario.departamento}
                      onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, departamento: e.target.value } }))}
                      required
                    >
                      <option value="">Selecione o departamento</option>
                      {departamentos.map((departamento) => (
                        <option key={departamento} value={departamento}>
                          {departamento}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Empresa</label>
                    <select
                      className="form-input"
                      value={dadosModais.novoUsuario.empresa}
                      onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, empresa: e.target.value } }))}
                      required
                    >
                      <option value="">Selecione a empresa</option>
                      {empresas.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {dadosModais.novoUsuario.departamento === 'Operações' && (
                  <div className="form-section">
                    <h4 className="section-title">Relação fundos</h4>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label form-label--required">Fundos</label>
                        <select
                          className="form-input"
                          value={dadosModais.novoUsuario.fundos_id}
                          onChange={(e) => setDadosModais(prev => ({ ...prev, novoUsuario: { ...prev.novoUsuario, fundos_id: e.target.value } }))}
                        >
                          <option value="">
                            {loadingFundos ? 'Carregando fundos...' :
                              errorFundos ? 'Erro ao carregar fundos' :
                                fundos.length === 0 ? 'Nenhum fundo disponível' :
                                  'Selecione os fundos'}
                          </option>
                          {fundos.map((fundo, index) => (
                            <option key={fundo.id || `fundo-${index}`} value={fundo.id}>
                              {fundo.nome}
                            </option>
                          ))}
                        </select>
                        {errorFundos && (
                          <small style={{ color: 'red', fontSize: '0.75rem' }}>
                            Erro ao carregar fundos: {(errorFundos as any)?.message || 'Erro desconhecido'}
                          </small>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label form-label--required">Tipo de relação</label>
                        <select
                          className="form-input"
                          value={dadosModais.novoUsuario.relacao || ''}
                          onChange={(e) =>
                            setDadosModais(prev => ({
                              ...prev,
                              novoUsuario: {
                                ...prev.novoUsuario,
                                relacao: e.target.value
                              }
                            }))
                          }
                          required
                        >
                          <option value="">Selecione o tipo de relação</option>
                          <option value="aprovador_cessao">Aprovador de Cessão</option>
                          <option value="batimento_cota">Batimento de Cota</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="fn-button fn-button--secondary"
                  onClick={() => fecharModal('novoUsuario')}
                >
                  <div className="fn-button__text">Cancelar</div>
                </button>
                <button
                  className="fn-button fn-button--emphasized"
                  onClick={() => {
                    console.log('Salvando novo usuário:', dadosModais.novoUsuario);
                    fecharModal('novoUsuario');
                  }}
                >
                  <div className="fn-button__text">Salvar</div>
                </button>
              </div>
            </div>
          </div>
        )}
      </PermissionGate> */}

      {/* <PermissionGate required="REGISTER_USER">
        {modais.edicaoUsuario && dadosModais.usuarioParaEdicao && (
          <div className="modal-overlay" onClick={() => fecharModal('edicaoUsuario')}>
            <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3 className="modal-title">Editar Usuário</h3>
              </div>
              <div className="modal-body">
                <div className="form-section">
                  <h4 className="section-title">Dados do Usuário</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Nome</label>
                      <input
                        type="text"
                        className="form-input"
                        value={dadosModais.usuarioParaEdicao.nome}
                        onChange={(e) => setDadosModais(prev => ({
                          ...prev,
                          usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, nome: e.target.value } : null
                        }))}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Sobrenome</label>
                      <input
                        type="text"
                        className="form-input"
                        value={dadosModais.usuarioParaEdicao.sobrenome}
                        onChange={(e) => setDadosModais(prev => ({
                          ...prev,
                          usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, sobrenome: e.target.value } : null
                        }))}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Email</label>
                      <input
                        type="email"
                        className="form-input"
                        value={dadosModais.usuarioParaEdicao.email}
                        onChange={(e) => setDadosModais(prev => ({
                          ...prev,
                          usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, email: e.target.value } : null
                        }))}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Nível de Acesso</label>
                      <select
                        className="form-input"
                        value={dadosModais.usuarioParaEdicao.nivel_acesso}
                        onChange={(e) => setDadosModais(prev => ({
                          ...prev,
                          usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, nivel_acesso: e.target.value } : null
                        }))}
                        required
                      >
                        <option value="">Selecione o nível de acesso</option>
                        {niveisAcesso.map((nivel) => (
                          <option key={nivel} value={nivel}>
                            {nivel}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Departamento</label>
                    <select
                      className="form-input"
                      value={dadosModais.usuarioParaEdicao.departamento}
                      onChange={(e) => setDadosModais(prev => ({
                        ...prev,
                        usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, departamento: e.target.value } : null
                      }))}
                      required
                    >
                      <option value="">Selecione o departamento</option>
                      {departamentos.map((departamento) => (
                        <option key={departamento} value={departamento}>
                          {departamento}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Empresa</label>
                    <select
                      className="form-input"
                      value={dadosModais.usuarioParaEdicao.empresa}
                      onChange={(e) => setDadosModais(prev => ({
                        ...prev,
                        usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, empresa: e.target.value } : null
                      }))}
                      required
                    >
                      <option value="">Selecione a empresa</option>
                      {empresas.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {dadosModais.usuarioParaEdicao.departamento === 'Operações' && (
                  <div className="form-section">
                    <h4 className="section-title">Relação fundos</h4>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label form-label--required">Fundos</label>
                        <select
                          className="form-input"
                          value={dadosModais.usuarioParaEdicao.fundos_id || ''}
                          onChange={(e) => setDadosModais(prev => ({
                            ...prev,
                            usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, fundos_id: e.target.value } : null
                          }))}
                        >
                          <option value="">
                            {loadingFundos ? 'Carregando fundos...' :
                              errorFundos ? 'Erro ao carregar fundos' :
                                fundos.length === 0 ? 'Nenhum fundo disponível' :
                                  'Selecione os fundos'}
                          </option>
                          {fundos.map((fundo, index) => (
                            <option key={fundo.id || `fundo-${index}`} value={fundo.id}>
                              {fundo.nome}
                            </option>
                          ))}
                        </select>
                        {errorFundos && (
                          <small style={{ color: 'red', fontSize: '0.75rem' }}>
                            Erro ao carregar fundos: {(errorFundos as any)?.message || 'Erro desconhecido'}
                          </small>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label form-label--required">Tipo de relação</label>
                        <select
                          className="form-input"
                          value={dadosModais.usuarioParaEdicao.relacao || ''}
                          onChange={(e) => setDadosModais(prev => ({
                            ...prev,
                            usuarioParaEdicao: prev.usuarioParaEdicao ? { ...prev.usuarioParaEdicao, relacao: e.target.value } : null
                          }))}
                          required
                        >
                          <option value="">Selecione o tipo de relação</option>
                          <option value="aprovador_cessao">Aprovador de Cessão</option>
                          <option value="batimento_cota">Batimento de Cota</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="fn-button fn-button--secondary"
                  onClick={() => fecharModal('edicaoUsuario')}
                >
                  <div className="fn-button__text">Cancelar</div>
                </button>
                <button
                  className="fn-button fn-button--emphasized"
                  onClick={() => {
                    console.log('Salvando edição do usuário:', dadosModais.usuarioParaEdicao);
                    fecharModal('edicaoUsuario');
                  }}
                >
                  <div className="fn-button__text">Salvar</div>
                </button>
              </div>
            </div>
          </div>
        )}
      </PermissionGate> */}
    </ErrorBoundary>
  );
};

export default CadastroUsuario;